<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model.lazy="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt" format="DD-MM-YYYY"
                    allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue=""
                    allowClear>
                    <a-select-option value="delivered">Delivered</a-select-option>
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process">On Process</a-select-option>
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="Bailout Report List" :manifestLink="getManifestLink" :dataList="bailoutSearch"
        :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "monitoringBailoutReport",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      BailoutReportList: [],
      search: "",
      status: undefined,
      transactionDt: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    bailoutSearch() {
      var self = this;
      let outputData = this.BailoutReportList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(this.status) >= 0
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(
          outputData,
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      return outputData;
    },
    getManifestLink() {
      let manifest = "SpecialManifestBailoutReport";
      if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpecialManifestBailoutReportFC";
      }else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
        manifest = "SpecialManifestBailoutReportVer";
      }else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        manifest = "SpecialManifestBailoutReportACC";
      }
      // if (localStorage.getItem("nvpn") === "/keuangan") {
      //   manifest = "SpclSPPDManifestKeu";
      // } else if (localStorage.getItem("nvpn") === "/pimpro") {
      //   manifest = "SpclSPPDManifestPimpro";
      // } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
      //   manifest = "SpclSPPDManifestAL";
      // } else if (localStorage.getItem("nvpn") === "/hrd") {
      //   manifest = "SpclSPPDManifestHrd";
      // } else if (localStorage.getItem("nvpn") === "/direktur") {
      //   manifest = "SpclSPPDManifestDir";
      // } else if (localStorage.getItem("nvpn") === "/sitejakarta") {
      //   manifest = "SpclSPPDManifestJkt";
      // } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
      //   manifest = "SpclSPPDManifestAcc";
      // } else if (localStorage.getItem("nvpn") === "/vpf") {
      //   return "SpclSPPDManifestVpf";
      // } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
      //   return "SpclSPPDManifestFin";
      // } else if (localStorage.getItem("nvpn") === "/opc/") {
      //   return "SpclSPPDManifestOPC";
      // } else {
      //   manifest = "SpclSPPDManifest";
      // }

      return manifest;
    },
  },
  methods: {
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/bailout_report",
        params: {
          id: localStorage.getItem("nvky"),
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          _.forEach(response.data.data, (data) => {
            this.BailoutReportList.push({
              title: data.no_lkb + " | " + data.tlc_pembuat,
              subdesc: [{ deskripsi: data.deskripsi}, 
              moment(data.tgl_buat).format(this.getDefaultDateFormat),
              "Usage : " + (data.total_pemakaian ? this.formatCurrency(data.currency,data.total_pemakaian).replace(",00", "") : this.formatCurrency('IDR',0).replace(",00", ""))],
              status: data.status,
              id: data.id_manifest,
              user_pembuat: data.tlc_pembuat,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              cancelStatus: data.cancel_sts,
              tgl_buat: data.tgl_buat,
              searchQ:
                data.no_lkb + " " +
                (data.deskripsi?data.deskripsi:'') + " " +
                moment(data.tgl_buat).format(this.getDefaultDateFormat) + " " +
                (data.total_pemakaian ? this.formatCurrency(data.currency,data.total_pemakaian).replace(",00", "") : this.formatCurrency('IDR',0).replace(",00", "")),
              // status_direktorat:{
              //   direktorat: data.direktorat,
              //   status: data.status_keuangan
              // }
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style lang="less">
.ant-list-item {
  &-action {
    background-color: whitesmoke;
    padding: 5px 0;
  }
}
</style>
